var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCough(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BoxContent/Header/LeftIcon36") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon36",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F7",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-2",
    transform: "translate(4.000000, 4.000000)",
    fill: "#181E34",
    opacity: 0.400000006
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.02654996,2.28867918 C3.38088917,-1.27335202 10.4556396,3.82532519 11.4333621,2.02927003 C11.5562492,1.75325347 11.9638865,1.82206667 11.9860435,2.14577895 C12.0819108,3.5470174 11.6931399,5.41337507 10.532604,6.27441841 L10.532604,8.1727387 C11.3743134,9.35577591 11.5192478,9.37391479 11.4785535,9.60857469 C11.4388099,9.83769745 11.2695613,9.82742512 10.4882535,10.3643743 L10.3034292,11.0075219 C10.2618082,11.1523598 10.122731,11.2569907 9.98167762,11.2220954 C9.11433155,11.0075219 8.70319055,11.1195765 8.60297226,11.3711915 L9.79879112,11.8840692 C9.92604907,11.9504861 9.98909968,12.1028995 9.94818621,12.2452049 C9.76760858,12.8640642 9.22240232,13.2881337 8.60297226,13.2915322 C8.32037934,13.2915322 8.20484129,13.2211151 7.31523484,13.0003935 L7.31472296,13.9936407 C7.3855083,14.0824258 3.33802015,13.2190912 2.63470052,12.8049518 L2.63470052,12.3545346 C1.43208101,10.7307416 0.600901712,8.99517486 0.223903967,7.32131851 C-0.118212985,5.80246371 -0.066878989,4.4266197 0.368326535,3.44719625 C0.7026922,2.69490984 1.36948212,2.38048103 2.02654996,2.28867918 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(12.246447, 15.246447) rotate(-315.000000) translate(-12.246447, -15.246447) ",
    x: 10.7464466,
    y: 14.7464466,
    width: 3,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(14.582963, 13.129410) rotate(18.000000) translate(-14.582963, -13.129410) ",
    x: 12.5829625,
    y: 12.6294102,
    width: 4,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(14.000000, 9.900000) rotate(-15.000000) translate(-14.000000, -9.900000) ",
    x: 12.5000003,
    y: 9.40000048,
    width: 3,
    height: 1,
    rx: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCough);
export default __webpack_public_path__ + "static/media/icon-cough.51ec6741d10e9fa27ca0a8d5b1ad8b4a.svg";
export { ForwardRef as ReactComponent };